import { CommonModule } from '@angular/common';
import { Component, computed, inject, Input, signal } from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyAbstractFilterChip, GalaxyFilterValueInterface } from '@vendasta/galaxy/filter/chips';
import { switchMap } from 'rxjs/operators';
import { CrmInjectionToken, SimplifiedUser } from '@galaxy/crm/static';
import { of } from 'rxjs';

@Component({
  selector: 'crm-user-filter-chip',
  template: `
    <ng-container *ngIf="selectedUsersText(); else loading">
      {{ selectedUsersText() }}
    </ng-container>
    <ng-template #loading>
      <div class="stencil-shimmer"></div>
    </ng-template>
  `,
  providers: [],
  styleUrls: ['./user-filter-chip.component.scss'],
  imports: [CommonModule, TranslateModule],
})
export class CrmUserFilterChipComponent implements GalaxyAbstractFilterChip {
  selectedUserIds = signal<string[]>([]);
  selectedUsers = signal<SimplifiedUser[]>([]);
  @Input() set initialValue(value: GalaxyFilterValueInterface[]) {
    this.selectedUserIds.set(value?.map((v) => v.string ?? '') || []);
  }

  selectedUsersText = computed(() => {
    if (this.selectedUsers().length === 0) {
      return '';
    }
    const firstUserName = this.selectedUsers()[0].displayName || this.selectedUserIds()[0];
    if (this.selectedUsers().length === 1) {
      return firstUserName;
    }
    return `${firstUserName} +${this.selectedUsers().length - 1}`;
  });

  private readonly userService = inject(CrmInjectionToken).services?.userService;

  constructor() {
    toObservable(this.selectedUserIds)
      .pipe(
        takeUntilDestroyed(),
        switchMap((userIds) => this.userService?.getMultiUsers(userIds) ?? of([])),
      )
      .subscribe((result) => this.selectedUsers.set(result));
  }
}
